import { Component, OnInit } from '@angular/core';
import { InputTextControlComponent } from '../input-text-control/input-text-control.component';

@Component({
  selector: 'app-input-datetime-control',
  templateUrl: './input-datetime-control.component.html',
  styleUrls: ['./input-datetime-control.component.scss']
})
export class InputDatetimeControlComponent {

  
}
